var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ElementStudioWidthAdjustmentBarAdjustmentHandle',{staticClass:"element-studio-width-adjustment-bar",attrs:{"on-dragging":_vm.dragging}})
}
var staticRenderFns = []

export { render, staticRenderFns }